export default __webpack_public_path__ + "static/media/newscrypto.0fb0a4f3.svg";